import { getEnvRequired } from '../../shared/utilities/env';

import { DossierId } from '../dossier/types';
import { ApiClient } from '../shared/api/client';

import { serializeTestimonialFromAPI } from './serializers';

import { TestimonialJSONAPIResponse } from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(true);

export async function getTestimonial(dossierId: DossierId) {
    const url = `${REQUEST_MANAGER_API_URL}/testimonial/${dossierId}`;
    const response = await apiClient.get<TestimonialJSONAPIResponse>(url);
    return serializeTestimonialFromAPI(response);
}
